import { render, staticRenderFns } from "./RbacEdit.vue?vue&type=template&id=2fb2436a"
import script from "./RbacEdit.vue?vue&type=script&lang=js"
export * from "./RbacEdit.vue?vue&type=script&lang=js"
import style0 from "./RbacEdit.vue?vue&type=style&index=0&id=2fb2436a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports